import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import { useViewModel } from '@utils';
import { observer } from 'mobx-react-lite';
import { LoginViewModel, ProfileViewModel } from '@views';
import Routes from './router/Routes';
import 'react-toastify/dist/ReactToastify.css';
import { MessageDialog } from './messageDialog';
import '../styles/app.scss';
import { ChangeRecurringMeetingDialog } from './changeRecurringMeetingDialog';

const App = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);
  const loginViewModel = useViewModel(LoginViewModel);
  
  function updateWindowHeightVariable() {
    const windowHeight = window.innerHeight;
    document.documentElement.style.setProperty('--window-height', `${windowHeight}px`);
  }
  
  // Вызов функции при загрузке страницы и при изменении размеров окна
  window.addEventListener('load', updateWindowHeightVariable);
  window.addEventListener('resize', updateWindowHeightVariable); 

  useEffect(() => {
    profileViewModel.onInit();
  }, [loginViewModel.authorized]);

  return (
    <div className="appWrapper">
      <ToastContainer
        position="bottom-left"
        autoClose={2000}
        limit={1}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
      />
      <MessageDialog />
      <ChangeRecurringMeetingDialog />
      <Routes />
    </div>
  );
});

export default App;
